export const PLAN_LIMITS = {
    free: {
        requestsPerHour: 300,
        apiRequestsPerHour: 100,
        maxWatchlistItems: 15,
        maxDashboards: 2,
        maxApiKeys: 1,
        maxHistoryYears: 10,
        exportEnabled: false,
    },
    pro: {
        requestsPerHour: 5000,
        apiRequestsPerHour: 5000,
        maxWatchlistItems: 200,
        maxDashboards: 25,
        maxApiKeys: 5,
        maxHistoryYears: 0,
        exportEnabled: true,
    },
    enterprise: {
        requestsPerHour: 50000,
        apiRequestsPerHour: 50000,
        maxWatchlistItems: 5000,
        maxDashboards: 500,
        maxApiKeys: 50,
        maxHistoryYears: 0,
        exportEnabled: true,
    },
};
export const PLAN_LABELS = {
    free: 'Free',
    pro: 'Pro',
    enterprise: 'Enterprise',
};
export class ApiError extends Error {
    statusCode;
    code;
    constructor(message, statusCode = 500, code = 'internal_error') {
        super(message);
        this.statusCode = statusCode;
        this.code = code;
        this.name = 'ApiError';
    }
}
//# sourceMappingURL=types.js.map